import React from "react";
import "./spinner.css";

const Spinner = () => {
  return (
    <div className="spinner">
      <div class="loader"></div>
    </div>
  );
};

export default Spinner;
